export class PagingModel {
  constructor(
    public itemsPerPage?: number,
    public totalItems?: number,
    public totalPages?: number,
    public pageNumber?: number,
    public optionalId?: number
  ) {}

  equals(value: PagingModel) {
    return this.itemsPerPage === value.itemsPerPage &&
      this.pageNumber === value.pageNumber &&
      this.totalItems === value.totalItems &&
      this.totalPages === value.totalPages &&
      this.optionalId === value.optionalId;
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/models/paging-model.ts